// extracted by mini-css-extract-plugin
export default {"wrapper":"StartPage_wrapper__P7eNY","logo":"StartPage_logo__ee9IX","content-window":"StartPage_content-window__hdOKS","list-item":"StartPage_list-item__AkCma"};